<template>
  <div class="md:flex md:flex-row md:flex-wrap">
    <div
      v-for="(item, index) in items"
      :key="item.id"
      :class="{'md:mr-6': ((index + 1) % 3 !== 0)}"
      class="flex justify-between border-b border-shadow-color py-6
      md:border md:rounded md:px-6 md:mb-8 custom-width cursor-pointer"
      @click="item.onClick"
    >
      <div class="flex flex-col">
        <BaseListHeader
          :title="item.title"
          :new-badge="item.isNew"
          class="mb-1"
        />
        <BaseGreyText class="mb-1">
          {{ item.date | moment('DD/MM/YYYY') }}
        </BaseGreyText>
        <BaseOrangeText>
          <BaseCurrencySpan :value="item.amount" /> {{ $t('invested') }}
        </BaseOrangeText>
      </div>
      <BaseRoundLogo :logo="item.logo" />
    </div>
  </div>
</template>

<script>
import BaseListHeader from './BaseListHeader.vue';
import BaseRoundLogo from './BaseRoundLogo.vue';
import BaseGreyText from './BaseGreyText.vue';
import BaseOrangeText from './BaseOrangeText.vue';
import BaseCurrencySpan from './BaseCurrencySpan.vue';

export default {

  name: 'BaseList',

  components: {
    BaseListHeader,
    BaseRoundLogo,
    BaseGreyText,
    BaseOrangeText,
    BaseCurrencySpan,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .custom-width {
    width: calc(100% * (1/2) - 16px);
  }
}
@media (min-width: 1120px) {
  .custom-width {
    width: calc(100% * (1/3) - 16px);
  }
}
</style>
